<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'User',
});
</script>

<template>
  <q-card class="no-box-shadow bg-transparent">
    <!--    <q-toolbar class="bg-primary text-white q-px-md">-->
    <!--      <h1 class="user-section&#45;&#45;title">-->
    <!--        <q-icon name="grid_view" size="1rem" class="q-mr-sm" />-->
    <!--        Son Görüntülenenler-->
    <!--      </h1>-->
    <!--    </q-toolbar>-->
    <!--    <div class="row">-->
    <!--      <div class="col-12 q-px-md q-py-md">asfasfs</div>-->
    <!--    </div>-->
    <q-card-section>
      <p class="text-h5 text-center">İşlemler menüsünden kullanıcı ile ilgili alanlara geçiş yapabilirsiniz</p>
    </q-card-section>
  </q-card>
</template>

<style scoped></style>
